import { render } from "./QuizType6.vue?vue&type=template&id=60cd71c7&scoped=true"
import script from "./QuizType6.vue?vue&type=script&lang=js"
export * from "./QuizType6.vue?vue&type=script&lang=js"

import "./QuizType6.vue?vue&type=style&index=0&id=60cd71c7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cd71c7"]])

export default __exports__